import React from 'react';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import ImageComponent from 'atoms/Image';
import InlineErrors from 'organisms/SearchStore/AU/Presentation/InlineErrors';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import {
  calculatePrice,
  getValueOrDefaultObject,
  getTernaryValue,
  isSupportedTenantCode,
} from 'common/utilities/utils';
import Accordian from 'atoms/Accordian/Accordian';

const ReorderAccordian = props => {
  const { currencySymbol, currencyConversionFactor, unavailableItem, orderDetails } = props;
  const { YOUR_ORDER, TOTAL, ITEM_NOT_UNAVAILABLE, ITEM_CURRENLTY_UNAVAILABLE, CART_ITEM } = TRANSLATE_MAPPING_KEY;
  const { foodLines = [], id: orderId, total } = getValueOrDefaultObject(orderDetails);
  const qty = foodLines?.reduce((acc, curr) => acc + curr?.quantity, 0);
  return (
    <div className='reorder-item-section'>
      <span className='reorder-section-heading'>{translateWithI18Next(YOUR_ORDER)}</span>
      {
        <div
          className={`${getTernaryValue(unavailableItem.length > 0, 'error-can-not-deliver', 'hide-error-container')}`}
        >
          <InlineErrors
            show={unavailableItem.length > 0}
            errorMsg={translateWithI18Next(ITEM_NOT_UNAVAILABLE)}
            errImage={IMAGE_PATH.Error_Yellow}
            cssClass='error-sub-container'
          />
        </div>
      }
      <section className='reorder-accordian'>
        <Accordian
          header={`${qty} ${translateWithI18Next(CART_ITEM)}${qty > 1 ? 's' : ''}`}
          key={`orderItem-${orderId}`}
        >
          {foodLines?.map(itemInfo => (
            <section className=''>
              <div className='reorder-order-item'>
                <div className='reorder-item-details'>
                  <div className='item-count-box mr'>
                    <span className='item-count ml'>{itemInfo?.quantity}</span>
                  </div>
                </div>
                <div className='item-desc-section'>
                  <span className='item-desc item-desc-bold'>{itemInfo?.item?.dname?.[0]?.value}</span>
                  {unavailableItem.length > 0 && unavailableItem.find(item => item?.id === itemInfo?.item?.id) && (
                    <span className='item-desc unavailable-msg'>
                      <ImageComponent srcFile={IMAGE_PATH.Error_Yellow} className={'unavailable-msg-icon'} />
                      {translateWithI18Next(ITEM_CURRENLTY_UNAVAILABLE)}
                    </span>
                  )}
                </div>
                {!isSupportedTenantCode() && (
                  <span className='item-amount item-desc-bold'>
                    {currencySymbol}
                    {calculatePrice(
                      itemInfo?.item?.quantity * itemInfo?.item?.unitPrice,
                      currencyConversionFactor,
                    )}{' '}
                  </span>
                )}
              </div>
            </section>
          ))}
          {!isSupportedTenantCode() && (
            <div className='reorder-payment-details mt-4 mb-4'>
              <span className='payment-total'>{translateWithI18Next(TOTAL)}</span>
              <span className='payment-total-amount'>
                {currencySymbol}
                {calculatePrice(total, currencyConversionFactor)}
              </span>
            </div>
          )}
        </Accordian>
      </section>
    </div>
  );
};

export default ReorderAccordian;
